import 'css-chunksrc/client/scenes/resourceActivation/infoResource/styles.scss';export default {
  "dataUser": "_dataUser_156b4_1",
  "profession": "_profession_156b4_9",
  "avatar": "_avatar_156b4_15",
  "name": "_name_156b4_25",
  "email": "_email_156b4_31"
};